import React from 'react';
import { Flex } from './shared/Flex';
import styled, { keyframes } from 'styled-components';
import { T } from "../Translation/index";
import { LangProps } from "../Translation/translation_types";

const LoadingWrapper = styled(Flex)`
  position: absolute;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 4;
  pointer-events: none;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(0, 0, 0, 0.55);
  padding: 12px 24px;
  border-radius: 12px;
`;

const Message = styled.span`
  font-size: 16px;
  color: #fff;
  font-weight: 500;
`;

const dotPulse = keyframes`
  0%, 20% { opacity: 0; transform: scale(0.8); }
  50% { opacity: 1; transform: scale(1); }
  80%, 100% { opacity: 0; transform: scale(0.8); }
`;

const Spinner = styled.div`
  display: flex;
  gap: 4px;
`;

const Dot = styled.div<{ delay: number }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #fff;
  animation: ${dotPulse} 1.4s ease-in-out infinite;
  animation-delay: ${({ delay }) => delay}s;
`;

const Loader = () => (
  <LoadingWrapper>
    <Content>
      <Spinner>
        <Dot delay={0} />
        <Dot delay={0.2} />
        <Dot delay={0.4} />
      </Spinner>
      <Message><T id={'loading' as LangProps} /></Message>
    </Content>
  </LoadingWrapper>
);
export default Loader;
